module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_116-9bde33f6303e86e1f09f350cfa76a233.png";